<template>
  <div class="slider">
    <div class="sc-slider-container">
      <div class="selected-ninja"></div><div class="unselected-ninja"></div>
      <div class="minvalue">{{ this.minValue }}</div>
      <input type="range" :min="minValue" :max="maxValue" v-model="inputValue" class="slider" @input="emitChange" :style="this.sliderColor">
      <div class="maxvalue"> {{ this.maxValue }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScSlider',
  data () {
    return {
      inputValue: this.value,
      percentageStep: 0,
      selectedColor: '',
      unselectedColor: '',
      fillValue: 0
    }
  },
  props: {
    minValue: {
      type: Number,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: false,
      default () {
        return this.minValue
      }
    }
  },
  watch: {
    inputValue: function (val, oldVal) {
      let diff = val - oldVal
      this.fillValue += diff
    }
  },
  computed: {
    percentage () {
      return this.fillValue * this.percentageStep
    },
    sliderColor () {
      return { background: `linear-gradient(to right, ${this.selectedColor} 0%,
              ${this.selectedColor} ${this.percentage}%,
              ${this.unselectedColor} ${this.percentage}%, ${this.unselectedColor} 100%)` }
    }
  },
  created () {
    let length = this.maxValue - this.minValue
    this.percentageStep = 100 / length
    this.fillValue = this.inputValue - this.minValue
  },
  mounted () {
    this.emitChange()
    let selectedTempDiv = this.$el.querySelector('.selected-ninja')
    let unselectedTempDiv = this.$el.querySelector('.unselected-ninja')
    this.selectedColor = getComputedStyle(selectedTempDiv).backgroundColor
    this.unselectedColor = getComputedStyle(unselectedTempDiv).backgroundColor
    selectedTempDiv.remove()
    unselectedTempDiv.remove()
    this.checkForIncorrectValue()
  },
  methods: {
    emitChange () {
      this.$emit('change', Number(this.inputValue))
    },
    checkForIncorrectValue () {
      if (this.value < this.minValue) {
        throw new RangeError('Initial value is lower than minValue')
      } else if (this.value > this.maxValue) {
        throw new RangeError('Initial value is lower than maxValue')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .minvalue, .maxvalue, .slider {
    display: inline-block;
  }

  .sc-slider-container {
    width: 100%;
    height: 100%;
  }

  .slider {
    -webkit-appearance: none;
    height: 100%;
    width: 70%;
    outline: none;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background-color: $sc-slider-color-handle;
    cursor: pointer;
    border-radius: 10px;
    border: solid 1px #b0bec5;
  }

  .selected-ninja {
    background: $sc-slider-color-selected;
  }

  .unselected-ninja {
    background: $sc-slider-color-unselected;
  }

  .maxvalue, .minvalue {
    height: 80%;
    opacity: 0.5;
    font-size: small;
    width: fit-content;
  }
  .maxvalue {
    color: $sc-slider-color-maxvalue;
    margin-left: 2%;
  }

  .minvalue {
    color: $sc-slider-color-minvalue;
    margin-right: 2%;
  }

  .slider {
    margin: 0 auto;
    height: $sc-slider-height;
  }
</style>
